/* jshint browserify: true */
'use strict';

import $ from 'jquery';
import Renderer from './renderer';

export default class BasicRenderer extends Renderer {
    constructor() {
        super();
        this.elementClassName = 'math-formula-basic';
    }

    render(elements) {
        $(elements).each((n, element) => {
            const code = this.getMathFromElement(element);

            $(element).text(code.latex);
        });

        return $.Deferred().resolve(elements);
    }
}